import {JsFormResponseHandlerObject} from '../jsFormTypes';
import {JRpcResponse, JsonRpcResponseFactory} from '../jsonRpc/jsonRpcResponseFactory';
import {JRpcErrResponse} from '../jsonRpc/jRpcErrResponse';
import {JRpcSuccResponse} from '../jsonRpc/jRpcSuccResponse';
import {Url} from '../url';
import {Localization} from '../../../localization/localization';
import {ErrorToolTip, TooltipDirection} from '../../newErrorToolTip';
import {isValidEmail} from '../validators';
import { disableJsFormHandler } from '../jsForm';
import {GtmSender} from '../../../marketing/GtmSender';
import {systemEvents} from '../../../constants/gameEvents';
import {StretchPopup} from '../../../popups/stretchPopup';
import { runFakeTutorial } from '../../../landings/widgets/fakeHardtutor';
import { configureHttpAuth } from '../../../startup/configureHttpAuth';
import { AuthStepConversionSend } from '../../../marketing/auth-step-conversion-send';

// TODO wtf is getMain? (rename)
function getMain(caller: HTMLElement|JQuery<HTMLElement>) {
    const result = $(caller).closest('.js-main');
    const id = $(result).attr('id');
    return $(`#${id}`);
}

let errorToolTip: ErrorToolTip;

$(function initRegistratioV3Form() {
    errorToolTip = ErrorToolTip.getTooltipElement();

    $('.js-close-button-reg').on('click', function handleV3CloseButtonClick() {
        const main = getMain(this);
        main.removeClass('step1 step2');
        main.addClass('step1');
        StretchPopup.stretch();
    });

    $('.js-form .button-back').on('click', function handleV3BackButtonClick() {
        const main = getMain(this);
        main.removeClass('step1 step2');
        main.addClass('step1');
        StretchPopup.stretch();
    });
});


// REGISTRATION V3
window.app.registrationV3step1 = registrationV3step1;
window.app.registrationV3step2 = registrationV3step2;
window.app.registrationV3step2V2 = registrationV3step2V2;

function registrationV3step1(data: JsFormResponseHandlerObject<JRpcResponse<{}>>) {
    const $form = data.form;
    const $termsCheckbox = $('.js-terms_agree', $form);
    const email = $('input[name=email]', $form).val() as string;
    const toolTipDirection: keyof typeof TooltipDirection = data.caller.data('tooltipdirection');
    const toolTipDirectionSide: TooltipDirection = TooltipDirection[toolTipDirection];
    const emailInput = $('input[name=email]', data.form);
    const emailInputContainer = emailInput.parents('.white_input');

    $('.error', data.form).removeClass('error');

    if ($termsCheckbox.length && !$termsCheckbox.hasClass('checked')) {
        errorToolTip.showTooltipElement(
            $termsCheckbox,
            toolTipDirectionSide as TooltipDirection,
            Localization._n('agree_error'),
            true
        );

        return false;
    }

    if (!isValidEmail(email)) {
        emailInputContainer.addClass('error');
        errorToolTip.showTooltipElement(
            emailInput,
            toolTipDirectionSide as TooltipDirection,
            Localization._n('wrong_data')
        );
        return false;
    }

    const main = getMain(data.caller);
    main.removeClass('step1 step2');
    main.addClass('step2');
    data.caller.removeAttr('disabled');
    StretchPopup.stretch();

    const authStepConversionSender = new AuthStepConversionSend(window.location);
    authStepConversionSender.send('2');

    return true;
}


async function registrationV3step2(data: JsFormResponseHandlerObject<JRpcResponse<{}>>) {
    const response = (new JsonRpcResponseFactory<{
        huid: number
    }>()).getJsonRpcResponseFromObject(data.response);
    const toolTipDirection: keyof typeof TooltipDirection = data.caller.data('tooltipdirection');
    const toolTipDirectionSide: TooltipDirection = TooltipDirection[toolTipDirection];
    const passwordInput = $('input[name=password]', data.form);
    const passwordInputContainer = passwordInput.parents('.white_input');

    $('.error', data.form).removeClass('error');

    if (response instanceof JRpcErrResponse) {
        passwordInputContainer.addClass('error');
        errorToolTip.showTooltipElement(
            passwordInput,
            toolTipDirectionSide as TooltipDirection,
            response.error.message
        );
        return;
    }

    if (response instanceof JRpcSuccResponse) {
        window.app.user_huid = response.result.huid;
        configureHttpAuth();
        GtmSender.fireMarketing(systemEvents.EMAIL_REG_SUCCESS);
        disableJsFormHandler(data.form);

        if (window.app.config?.landings?.enableFakeHardtutor) {
            runFakeTutorial();
            return;
        }

        location.reload();
        return;
    }

    passwordInputContainer.addClass('error');
    errorToolTip.showTooltipElement(
        passwordInput,
        toolTipDirectionSide as TooltipDirection,
        Localization._n('common_error')
    );
}


function registrationV3step2V2(data: JsFormResponseHandlerObject<JRpcResponse<{}>>) {
    const response = (new JsonRpcResponseFactory<{}>()).getJsonRpcResponseFromObject(data.response);
    const toolTipDirection: keyof typeof TooltipDirection = data.caller.data('tooltipdirection');
    const toolTipDirectionSide: TooltipDirection = TooltipDirection[toolTipDirection];

    if (response instanceof JRpcSuccResponse) {
        const authStepConversionSender = new AuthStepConversionSend(window.location);
        authStepConversionSender.send('2');

        window.app.openDownStep2AndDownload();
        return;
    }

    if (response instanceof JRpcErrResponse) {
        errorToolTip.showTooltipElement(
            $('input[name=password]', data.form),
            toolTipDirectionSide as TooltipDirection,
            response.error.message
        );
        return;
    }

    errorToolTip.showTooltipElement(
        $('input[name=password]', data.form),
        toolTipDirectionSide as TooltipDirection,
        Localization._n('common_error')
    );
}

window.app.downloadLauncher = function downloadLauncher() {
    try {
        GtmSender.fireMarketing(systemEvents.INSTALL);
        GtmSender.fireMarketing(systemEvents.REGISTRATION);
    } catch (error) {
        console.error(error);
        // eslint-disable-next-line no-unused-expressions
        window?.Sentry.captureException(error);
    }

    setTimeout(function redirectToDownload() {
        location.href = Url.getNoLangUrl('download');
    }, 800);
};

window.app.openDownloadStep2 = function openDownloadStep2() {
    const reg = $('#registration');
    const inputPass = $('input[name=password]', reg).parent();
    const buttonStep2 = $('button[data-handler=registrationV3step2V2]');

    reg.removeClass('step1 step2');
    reg.addClass('step2');
    inputPass.hide();

    buttonStep2.data('handler', 'downloadLauncher');
    $('.js-close-button-reg', reg).text('');
};

window.app.openDownStep2AndDownload = function openDownStep2AndDownload() {
    window.app.openDownloadStep2();
    window.app.downloadLauncher();
};
